export default __webpack_public_path__ + "static/media/tracker.38ff5b14.svg";